// src/hooks/useRetornoAsesor.js
import { useUsers } from "../metodos/userContext";
import { useConfiguracion } from "../metodos/ConfiguracionContext";

export const useRetornoAsesor = () => {
    const { configuracion, loadingConfiguracion } = useConfiguracion();
    const { usuario, loadingUsuario, errorUsuario } = useUsers();
    
    const retornoAsesor = () => {
        if (!usuario || !configuracion) return '';
        return `${usuario.nombrewhatsapp} - ${configuracion.nombreEmpresa}`;
    };

    const referidoPor = (nombre_empresa) =>{
        let referido = "";

        if(configuracion.nombreEmpresa == nombre_empresa){
            referido = "";
        }else{
            referido = configuracion.nombreEmpresa;
        }

        return referido;

    }

    //seleccionar identificador de codigo
    const retornarIdentificadorCodigo = (solicitud) =>{
        const servicio = solicitud.Servicio;

        if(servicio == "PARCIAL"){
            return 'P';
        }
        if(servicio == "QUIZ"){
            return 'Q';
        }
        if(servicio == "TALLER"){
            return 'T';
        }
        if(servicio == "CLASES PERSONALIZADAS"){
            return 'A';
        }
        if(servicio == "TESIS"){
            return 'TES';
        }

        return 'NO-PROGRAMADO';

    }
    
    const loading = loadingConfiguracion || loadingUsuario;
    const error = errorUsuario;
    
    return {
        retornoAsesor,
        referidoPor,
        nombreAsesor: retornoAsesor(),
        loading,
        error,
        usuario,
        configuracion,
        retornarIdentificadorCodigo,
    };
};

export const useNombreEmpresaReal = (nombreEmpresa) =>{
  let nombreEmpresaReal = "";
  if (nombreEmpresa === 'DUFY_ASESORIAS') {
    nombreEmpresaReal = nombreEmpresa.replace(/_/g, ' ');
  }else{
    nombreEmpresaReal = nombreEmpresa;
  }
  return nombreEmpresaReal;
}

export const useisUserAdmin = (usuario) =>{
    const isAdmin = (usuario?.rol === "ADMIN" || usuario.rol === "COLABORADOR") ? true : false;
    return isAdmin;
}